<template>
  <div
    class="green-operation-letter__history"
  >
    <HKLLeftRight

      v-if="isTenant && isUnderReview"
      class="green-operation-letter__history-item row align-middle align-spaced"
    >
      <div class="green-operation-letter-comments__title font-bold">
        {{ $t('tenancy.greenOperation.sustainabilityPartnershipProgramme') }}
      </div>
      <div class="tip">
        <span class="tip__text">{{ $t('tenantProjects.submission.comment.underReview') }}</span>
      </div>
    </HKLLeftRight>
    <template v-if="completedLetters.length">
      <HKLLeftRight
        v-for="(item, index) in completedLetters"
        :key="index"
        class="green-operation-letter__history-item align-middle"
      >
        <div
          class="green-operation-letter__history-title"
          @click="() => openPreviousHistory(item)"
          v-html="item.title"
        />
        <HKLGrayHint :fontSize="11">
          {{ item.tipWording }}
        </HKLGrayHint>
      </HKLLeftRight>
      <GreenOperationPreviewSendModal
        ref="previewSendModal"
        :previewData="previewLetter || {}"
      />
    </template>
  </div>
</template>

<script>
import { useRefModal } from '@/controls/Modal/modal.hook'
import GreenOperationPreviewSendModal from './GreenOperationPreviewSendModal'
import {
  useGreenOperationLetters,
  useLatestLetterStatus,
} from '../GreenOperationLetter.hook'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight'
import HKLGrayHint from '@/controls/HKLGrayHint'
import { useStoreGetters } from '@/store/index'
import dateUtil from '@/utils/dateUtil'
import { computed } from '@vue/composition-api'
import lodash from 'lodash'
import { getCurrentInstance, ref } from 'vue-demi'
import { GO_LETTER_HISTORY_ACTION_TYPE, GREEN_OPERATION_LETTER_STATUS } from '../consts'
import i18n from '@/utils/i18n'

export default {
  components: {
    HKLLeftRight,
    HKLGrayHint,
    GreenOperationPreviewSendModal,
  },
  setup () {
    const userStore = useStoreGetters('user', ['isHKlandUser', 'isTenant'])
    const { proxy } = getCurrentInstance()
    const { data: letters } = useGreenOperationLetters()
    const { modal: previewSendModal, open: openPreviewSendModal } = useRefModal()

    const { isUnderReview } = useLatestLetterStatus()
    const completedLetters = computed(() => {
      const result = letters.value.filter(item => item.status === GREEN_OPERATION_LETTER_STATUS.COMPLETED)
      const total = result.length
      return lodash.orderBy(result, ['createdAt'], ['desc'])
        .map((item, index) => {
          const result = {
            ...item,
            title: i18n.t('tenancy.greenOperation.historyTitleWithDuration',
              [total - index, formatDuration(item, 0), formatDuration(item, 1)]),
            tipWording: setUpTipWording(item.histories),
          }
          return result
        })
    })
    const formatDuration = (letter, durationIndex) => {
      const duration = letter.duration || []
      return dateUtil.formatByLongDate(duration[durationIndex], 'LL')
    }
    const setUpTipWording = (histories) => {
      const shouldFilteredActionType = [GO_LETTER_HISTORY_ACTION_TYPE.SEND]
      if (userStore.isHKlandUser.value) {
        shouldFilteredActionType.push(GO_LETTER_HISTORY_ACTION_TYPE.RESEND)
      }
      const latestHistory = lodash.orderBy(histories, 'createdAt', 'desc').filter(item => shouldFilteredActionType.includes(item.actionType))[0] || {}
      const templateParamArray = getActionHistoryInfo(latestHistory)
      const tipWordingMaps = {
        [GO_LETTER_HISTORY_ACTION_TYPE.SEND]: 'tenantProjects.submission.sentByOn',
        [GO_LETTER_HISTORY_ACTION_TYPE.RESEND]: 'tenantProjects.submission.resentByOn',
      }
      if (userStore.isTenant.value) {
        Object.assign(tipWordingMaps, {
          [GO_LETTER_HISTORY_ACTION_TYPE.SEND]: 'tenantProjects.submission.receivedOn',
        })
        templateParamArray.shift()
      }
      return proxy.$t(tipWordingMaps[lodash.get(latestHistory, 'actionType')], templateParamArray)
    }

    const getActionHistoryInfo = (history) => {
      const displayName = lodash.get(history, 'createdBy.displayName', proxy.$t('emptyValue'))
      const actionTime = dateUtil.formatDate(lodash.get(history, 'createdAt'), true)
      return [displayName, actionTime]
    }

    const previewLetter = ref(null)
    const openPreviousHistory = (item) => {
      previewLetter.value = item
      openPreviewSendModal()
    }

    return {
      ...userStore,
      letters,
      isUnderReview,
      previewLetter,
      completedLetters,
      openPreviousHistory,
      previewSendModal,
      openPreviewSendModal,
      formatDuration,

    }
  },
}
</script>

<style lang="scss" scoped>
.green-operation-letter__history {
  margin-top: 15px;
  .green-operation-letter__history-item {
    display: flex;
    justify-content: space-between;
    border: 1px solid #e0e1e4;
    color: #0c3a58;
    padding: 9px 14px 11px 17px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .green-operation-letter__history-title {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
